import { render, staticRenderFns } from "./ChatNew.vue?vue&type=template&id=2f680521&scoped=true"
import script from "./ChatNew.vue?vue&type=script&lang=ts"
export * from "./ChatNew.vue?vue&type=script&lang=ts"
import style0 from "./ChatNew.vue?vue&type=style&index=0&id=2f680521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f680521",
  null
  
)

export default component.exports